import { formatImageURL } from "../utils";
import type { ListingVideoEntry } from "./videoValidation";

export type { ListingVideoEntry };

/** Parse listing `videoLoc` into structured entries (order preserved). */
export function parseListingVideoEntries(videoLoc: unknown): ListingVideoEntry[] {
  try {
    if (videoLoc == null || videoLoc === "") return [];
    let value: unknown = videoLoc;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return [];
      try {
        value = JSON.parse(trimmed);
      } catch {
        return [];
      }
    }
    if (!Array.isArray(value)) return [];
    const entries: ListingVideoEntry[] = [];
    for (const item of value) {
      if (typeof item === "string" && item.trim()) {
        entries.push({ key: item.trim(), contentType: "video/mp4" });
        continue;
      }
      if (
        item &&
        typeof item === "object" &&
        typeof (item as ListingVideoEntry).key === "string" &&
        (item as ListingVideoEntry).key.trim()
      ) {
        const entry = item as ListingVideoEntry;
        entries.push({
          key: entry.key.trim(),
          contentType: entry.contentType || "video/mp4",
          durationSeconds: entry.durationSeconds,
          bytes: entry.bytes,
        });
      }
    }
    return entries;
  } catch {
    return [];
  }
}

export function resolveListingVideoUrl(key?: string | null): string {
  if (!key) return "";
  return formatImageURL(key);
}

export function stringifyListingVideoEntries(
  entries: ListingVideoEntry[]
): string {
  return JSON.stringify(
    entries.map((e) => ({
      key: e.key,
      contentType: e.contentType || "video/mp4",
      ...(e.durationSeconds != null
        ? { durationSeconds: e.durationSeconds }
        : {}),
      ...(e.bytes != null ? { bytes: e.bytes } : {}),
    }))
  );
}
